/**
 * Normalize the browser animation API across implementations. This requests
 * the browser to schedule a repaint of the window for the next animation frame.
 * Checks for cross-browser support, and, failing to find it, falls back to setTimeout.
 * @param {function}    callback  Function to call when it's time to update your animation for the next repaint.
 * @param {HTMLElement} element   Optional parameter specifying the element that visually bounds the entire animation.
 * @return {number} Animation frame request.
 */ if (!window.requestAnimationFrame) window.requestAnimationFrame = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame || function(callback) {
    return window.setTimeout(callback, 17 /*~ 1000/60*/ );
};
/**
 * Cancels an animation frame request.
 * Checks for cross-browser support, falls back to clearTimeout.
 * @param {number}  Animation frame request.
 */ if (!window.cancelRequestAnimationFrame) window.cancelRequestAnimationFrame = window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.mozCancelRequestAnimationFrame || window.msCancelRequestAnimationFrame || window.oCancelRequestAnimationFrame || window.clearTimeout;
/* Object that contains our utility functions.
 * Attached to the window object which acts as the global namespace.
 */ const $820877bea407f5fe$var$utils = {};
/**
 * Keeps track of the current mouse position, relative to an element.
 * @param {HTMLElement} element
 * @return {object} Contains properties: x, y, event
 */ $820877bea407f5fe$var$utils.captureMouse = function(element) {
    var mouse = {
        x: 0,
        y: 0,
        event: null
    }, body_scrollLeft = document.body.scrollLeft, element_scrollLeft = document.documentElement.scrollLeft, body_scrollTop = document.body.scrollTop, element_scrollTop = document.documentElement.scrollTop, offsetLeft = element.offsetLeft, offsetTop = element.offsetTop;
    element.addEventListener("mousemove", function(event) {
        var x, y;
        if (event.pageX || event.pageY) {
            x = event.pageX;
            y = event.pageY;
        } else {
            x = event.clientX + body_scrollLeft + element_scrollLeft;
            y = event.clientY + body_scrollTop + element_scrollTop;
        }
        x -= offsetLeft;
        y -= offsetTop;
        mouse.x = x;
        mouse.y = y;
        mouse.event = event;
    }, false);
    return mouse;
};
/**
 * Returns a color in the format: '#RRGGBB', or as a hex number if specified.
 * @param {number|string} color
 * @param {boolean=}      toNumber=false  Return color as a hex number.
 * @return {string|number}
 */ $820877bea407f5fe$var$utils.parseColor = function(color, toNumber) {
    if (toNumber === true) {
        if (typeof color === "number") return color | 0 //chop off decimal
        ;
        if (typeof color === "string" && color[0] === "#") color = color.slice(1);
        return window.parseInt(color, 16);
    } else {
        if (typeof color === "number") color = "#" + ("00000" + (color | 0).toString(16)).substr(-6) //pad
        ;
        return color;
    }
};
/**
 * Converts a color to the RGB string format: 'rgb(r,g,b)' or 'rgba(r,g,b,a)'
 * @param {number|string} color
 * @param {number}        alpha
 * @return {string}
 */ $820877bea407f5fe$var$utils.colorToRGB = function(color, alpha) {
    //number in octal format or string prefixed with #
    if (typeof color === "string" && color[0] === "#") color = window.parseInt(color.slice(1), 16);
    alpha = alpha === undefined ? 1 : alpha;
    //parse hex values
    var r = color >> 16 & 0xff, g = color >> 8 & 0xff, b = color & 0xff, a = alpha < 0 ? 0 : alpha > 1 ? 1 : alpha;
    //only use 'rgba' if needed
    if (a === 1) return "rgb(" + r + "," + g + "," + b + ")";
    else return "rgba(" + r + "," + g + "," + b + "," + a + ")";
};
/**
 * Determine if a rectangle contains the coordinates (x,y) within it's boundaries.
 * @param {object}  rect  Object with properties: x, y, width, height.
 * @param {number}  x     Coordinate position x.
 * @param {number}  y     Coordinate position y.
 * @return {boolean}
 */ $820877bea407f5fe$var$utils.containsPoint = function(rect, x, y) {
    return !(x < rect.x || x > rect.x + rect.width || y < rect.y || y > rect.y + rect.height);
};
/**
 * Determine if two rectangles overlap.
 * @param {object}  rectA Object with properties: x, y, width, height.
 * @param {object}  rectB Object with properties: x, y, width, height.
 * @return {boolean}
 */ $820877bea407f5fe$var$utils.intersects = function(rectA, rectB) {
    return !(rectA.x + rectA.width < rectB.x || rectB.x + rectB.width < rectA.x || rectA.y + rectA.height < rectB.y || rectB.y + rectB.height < rectA.y);
};
var $820877bea407f5fe$export$2e2bcd8739ae039 = $820877bea407f5fe$var$utils;


var $5440e9199a418654$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
$5440e9199a418654$exports = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}


class $8d2352631c7dc17a$var$Ball {
    constructor(options = {}){
        this.x = options.x || 0;
        this.y = options.y || 0;
        this.radius = options.radius || 20;
        this.vx = options.vx;
        this.vy = options.vy;
        this.style = options.style || "red";
        this.isImageStyle = this.isURL(this.style);
        if (this.isImageStyle) {
            const image = new Image();
            image.src = this.style;
            image.onload = ()=>{
                this.image = image;
            };
            image.error = ()=>{
                console.error("[canvas-pendulum] load image error:" + this.style);
            };
        }
        this.rotation = options.rotation || 0;
        this.outLineWidth = options.outLineWidth || 1;
    }
    isURL(url) {
        return typeof url === "string" && (url.startsWith("http") || url.startsWith(".") || url.startsWith("/"));
    }
    draw(context) {
        context.save();
        context.translate(this.x, this.y);
        context.rotate(this.rotation);
        context.lineWidth = this.outLineWidth;
        context.beginPath();
        context.arc(0, 0, this.radius, 0, Math.PI * 2, true);
        context.closePath();
        if (this.isImageStyle) {
            if (this.image) {
                context.save();
                context.clip();
                context.drawImage(this.image, -this.radius + this.outLineWidth / 2, -this.radius + this.outLineWidth / 2, this.radius * 2 - this.outLineWidth, this.radius * 2 - this.outLineWidth);
                context.restore();
            }
        } else {
            context.fillStyle = this.style;
            context.fill();
        }
        if (this.outLineWidth > 0) context.stroke();
        context.restore();
    }
    getBounds() {
        return {
            x: this.x - this.radius,
            y: this.y - this.radius,
            width: this.radius * 2,
            height: this.radius * 2
        };
    }
    isPointInBall(x, y) {
        return Math.pow(x - this.x, 2) + Math.pow(y - this.y, 2) <= Math.pow(this.radius, 2);
    }
}
var $8d2352631c7dc17a$export$2e2bcd8739ae039 = $8d2352631c7dc17a$var$Ball;


class $35da740d59af89ba$var$CanvasPendulum extends (0, $5440e9199a418654$exports.EventEmitter) {
    constructor(options = {}){
        super();
        options = options || {};
        this.el = options.el;
        if (typeof this.el === "string") this.el = document.querySelector(this.el);
        if (this.el) {
            if (this.el.tagName === "CANVAS") this.canvas = this.el;
            else if (this.el.appendChild) {
                this.canvas = document.createElement("canvas");
                this.el.appendChild(this.canvas);
            } else throw new Error("\u53C2\u6570el\u9519\u8BEF");
        } else {
            this.canvas = document.createElement("canvas");
            document.body.appendChild(this.canvas);
        }
        this.cWidth = options.width || this.canvas.width || 300;
        this.cHeight = options.height || this.canvas.height || 150;
        if (this.canvas.width !== this.cWidth) this.canvas.width = this.cWidth;
        if (this.canvas.height !== this.cHeight) this.canvas.height = this.cHeight;
        this.context = this.canvas.getContext("2d");
        this.T = options.T || 1000 // 周期
        ;
        this.ballNum = options.ballNum || 1;
        this.ballWidth = options.ballWidth || 40;
        this.maxAngle = options.maxAngle || 20 // 最大的角度
        ;
        this.outLineWidth = Math.min(options.outLineWidth || 1, this.ballWidth) // 边框大小
        ;
        this.initSpeed = 2 * Math.PI / this.T;
        this.intX = this.cWidth / 2 - this.ballNum / 2 * (this.ballWidth + this.outLineWidth);
        this.maxRadian = Math.PI * (this.maxAngle || 10) / 180;
        this.startTime = +new Date();
        this.time = this._getTimer();
        let lineWidth = options.lineWidth || (this.cHeight - this.ballWidth) * 90 / 100;
        let defaultBallStyle = "red";
        let ballStyles = options.ballStyles || defaultBallStyle;
        this.pendulums = new Array(this.ballNum).fill(0).map((item, index)=>({
                ball: new (0, $8d2352631c7dc17a$export$2e2bcd8739ae039)({
                    radius: this.ballWidth / 2,
                    style: Array.isArray(ballStyles) ? ballStyles[index] || defaultBallStyle : ballStyles,
                    outLineWidth: this.outLineWidth
                }),
                radius: this.ballWidth / 2,
                fixedPoint: [
                    this.intX + index * (this.ballWidth + this.outLineWidth) + this.ballWidth / 2,
                    0
                ],
                line: lineWidth,
                spend: index === 0 ? this.initSpeed : 0,
                w: 0
            }));
        this._status = "pause";
        let mouse = (0, $820877bea407f5fe$export$2e2bcd8739ae039).captureMouse(this.canvas);
        this.canvas.addEventListener("click", (e)=>{
            this.pendulums.some((item, index)=>{
                let isInBall = item.ball.isPointInBall(mouse.x, mouse.y);
                if (isInBall) this.emit("ballClick", {
                    spend: item.spend,
                    index: index,
                    x: mouse.x,
                    y: mouse.y
                });
                return isInBall;
            });
        });
    }
    _getTimer() {
        return +new Date() - this.startTime;
    }
    _checkConflict(ball1, ball2) {
        if (!ball1 || !ball2) return false;
        return Math.pow(ball1.radius + ball2.radius, 2) > Math.pow(ball2.x - ball1.x, 2) + Math.pow(ball2.y - ball1.y, 2);
    }
    start() {
        if (this._status !== "running") {
            this._status = "running";
            this._run();
        }
        return this;
    }
    stop() {
        this._status = "pause";
        return this;
    }
    _run() {
        if (this._status === "running") window.requestAnimationFrame(this._run.bind(this), this.canvas);
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        const elspsed = this._getTimer() - this.time;
        this.time = this._getTimer();
        // 绘制
        this.pendulums.forEach((item)=>{
            // item.w+=item.spend;
            item.w += item.spend * elspsed;
            const angle = Math.sin(item.w) * this.maxRadian;
            item.ball.x = item.fixedPoint[0] - (item.line + item.radius) * Math.sin(angle);
            item.ball.y = item.fixedPoint[1] + (item.line + item.radius) * Math.cos(angle);
            // 划线
            this.context.save();
            this.context.lineWidth = 1;
            this.context.beginPath();
            this.context.moveTo(item.fixedPoint[0] || 9, item.fixedPoint[1] || 0);
            this.context.lineTo(item.fixedPoint[0] - item.line * Math.sin(angle), item.fixedPoint[1] + item.line * Math.cos(angle));
            this.context.stroke();
            this.context.restore();
            if (angle !== 0) item.ball.rotation = angle;
            item.ball.draw(this.context);
        });
        // 碰撞检测
        if (this.pendulums.length >= 2 && (this._checkConflict(this.pendulums[0].ball, this.pendulums[1].ball) || this._checkConflict(this.pendulums[this.pendulums.length - 1].ball, this.pendulums[this.pendulums.length - 2].ball))) {
            this.emit("ping", {
                isFrist: this.pendulums[0].spend > 0
            });
            const spend = this.pendulums[0].spend;
            const w = this.pendulums[0].w;
            this.pendulums[0].spend = this.pendulums[this.pendulums.length - 1].spend;
            this.pendulums[0].w = this.pendulums[this.pendulums.length - 1].w;
            this.pendulums[this.pendulums.length - 1].spend = spend;
            this.pendulums[this.pendulums.length - 1].w = w;
        }
    }
}
var $35da740d59af89ba$export$2e2bcd8739ae039 = $35da740d59af89ba$var$CanvasPendulum;


window.onload = function() {
    const canvasPendulum = new (0, $35da740d59af89ba$export$2e2bcd8739ae039)({
        el: document.getElementById("canvas"),
        ballNum: 4,
        ballStyles: [
            "https://www.kai666666.com/images/avatar.png",
            "#00ff00",
            "orange",
            "transparent"
        ]
    });
    canvasPendulum.start();
    canvasPendulum.on("ping", (e)=>{
        // 小球碰撞事件
        // let { isFrist } = e; // 是否第一个小球被碰撞了 false为最后一个小球碰撞了
        console.log("\u78B0\u649E\u4E86");
    });
    canvasPendulum.on("ballClick", (e)=>{
        // 小球被点击事件
        // let { spend,index, x, y } = e; // spend不等于0表示小球在运动
        console.log("\u5C0F\u7403\u88AB\u70B9\u51FB");
    });
};


//# sourceMappingURL=index.2c55252f.js.map
